import { FC } from 'react'
import gclasses from '../../../../../CRMSettings/global.module.css'
import classes from './index.module.css'
import cn from 'classnames'
import { LeadStatus } from '@/api/types/crm.types'
import { DeleteOutlined } from '@ant-design/icons'
import { formatDate, formatTime } from '../../../../utils/formatData'

interface StatusItemProps {
  leadStatus: LeadStatus
  onDelete: (leadStatus: LeadStatus) => void
  isDeleteButton: boolean
  backgroundColor?: string
}

const StatusItem: FC<StatusItemProps> = ({
  leadStatus,
  onDelete,
  isDeleteButton,
  backgroundColor,
}) => {
  return (
    <div
      key={leadStatus.id}
      className={classes.statusListItem}
      style={{ backgroundColor }}
    >
      <div className={classes.statusListItemDate}>
        <span className={classes.bold}>
          {formatDate(leadStatus.created_at)}
        </span>
        <span>{formatTime(leadStatus.created_at)}</span>
      </div>
      <div className={classes.statusListItemContent}>
        <span
          className={classes.statusListItemColor}
          style={{ backgroundColor: leadStatus.status.color }}
        />
        <span className={classes.statusListItemName}>
          {leadStatus.status.name}
        </span>
      </div>
      {isDeleteButton ? (
        <DeleteOutlined
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
          className={cn(gclasses.activeIcon, classes.deleteIcon)}
          onClick={() => onDelete(leadStatus)}
        />
      ) : (
        <div className={cn(gclasses.emptyIcon, classes.deleteIcon)} />
      )}
    </div>
  )
}

export default StatusItem
